import * as React from 'react';
import * as styles from './table.module.scss';

interface Props {
  children: React.ReactNode;
}

const TableHead = ({ children }: Props) => {
  return (
    <thead className={styles.tableHead}>
      <tr>{children}</tr>
    </thead>
  );
};

export default TableHead;
